/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Lucas Pastur Romay - CPO & Co-Founder, Artiso AI",
  description:
    "CPO & Co-Founder at Artiso AI. We build AI tools for fashion creatives, from moodboards to tech packs. PhD in AI. Ex-Mango, ex-Grifols.",
  og: {
    title: "Lucas Pastur Romay - CPO & Co-Founder, Artiso AI",
    type: "website",
    url: "https://lucas-pastur-romay.com/",
  },
};

//Home Page
const greeting = {
  title: "Lucas Pastur Romay",
  logo_name: "LucasPastur",
  nickname: "CPO & Co-Founder at Artiso AI",
  subTitle:
    "I co-founded Artiso AI, where we build AI tools that help fashion teams go from first sketch to final campaign faster. Before that, I led Generative AI at Mango (training 100+ creatives) and designed AI platforms at Grifols. PhD in Artificial Intelligence.",
  resumeLink: "https://www.linkedin.com/in/lucas-pastur-romay/",
  portfolio_repository: "https://github.com/pasturl/pasturl.github.io ",
  githubProfile: "https://github.com/pasturl",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/pasturl",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/lucas-pastur-romay/?locale=en_US",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:lucas.pastur@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Artiso AI",
    link: "https://www.artiso.ai",
    fontAwesomeIcon: "fa-rocket",
    fontAwesomePrefix: "fas",
    backgroundColor: "#000000",
  },
];

const skills = {
  data: [
    {
      title: "Agentic AI & Generative AI",
      fileName: "DataScienceImg",
      skills: [
        "Building AI agents that run multi-step fashion workflows: moodboards, prints, tech packs",
        "Took Generative AI from zero to daily use at Mango, training 100+ creatives",
        "Designed AI reference architectures at Grifols across 20+ business use cases",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { backgroundColor: "transparent", color: "#3776AB" },
          url: "https://www.python.org/",
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: { backgroundColor: "transparent" },
          url: "https://pytorch.org/",
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: { backgroundColor: "transparent" },
          url: "https://www.tensorflow.org/",
        },
        {
          skillName: "HuggingFace",
          fontAwesomeClassname: "noto:hugging-face",
          style: { backgroundColor: "transparent" },
          url: "https://huggingface.co/",
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: { color: "#1C3C3C" },
          url: "https://www.langchain.com/",
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: { color: "#412991" },
          url: "https://openai.com/",
        },
      ],
    },
    {
      title: "AI Product & Platform Development",
      fileName: "FullStackImg",
      skills: [
        "Turning how fashion teams actually work into AI-native product features",
        "Full product cycle: moodboards, silhouettes, prints, tech packs, campaign content",
        "SaaS platforms with visual interfaces that designers and creatives can use directly",
      ],
      softwareSkills: [
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
          url: "https://react.dev/",
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: { color: "#000000" },
          url: "https://nextjs.org/",
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: { color: "#009688" },
          url: "https://fastapi.tiangolo.com/",
        },
        {
          skillName: "Streamlit",
          fontAwesomeClassname: "simple-icons:streamlit",
          style: { color: "#FF4B4B" },
          url: "https://streamlit.io/",
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: { color: "#3178C6" },
          url: "https://www.typescriptlang.org/",
        },
      ],
    },
    {
      title: "Cloud, Big Data & MLOps",
      fileName: "CloudInfraImg",
      skills: [
        "Production AI on AWS, GCP, and Azure",
        "Re-architected Mango's Big Data pipelines (Databricks, PySpark, Airflow), cut compute costs 50%",
        "ML model deployment at scale with CI/CD, Docker, and Kubernetes",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
          url: "https://aws.amazon.com/",
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: { color: "#4285F4" },
          url: "https://cloud.google.com/",
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: { color: "#0089D6" },
          url: "https://azure.microsoft.com/",
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: { color: "#336791" },
          url: "https://www.postgresql.org/",
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: { color: "#47A248" },
          url: "https://www.mongodb.com/",
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
          url: "https://www.docker.com/",
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: { color: "#326CE5" },
          url: "https://kubernetes.io/",
        },
        {
          skillName: "Airflow",
          fontAwesomeClassname: "logos:airflow-icon",
          style: { color: "#326CE5" },
          url: "https://airflow.apache.org/",
        },
        {
          skillName: "Spark",
          fontAwesomeClassname: "logos:apache-spark",
          style: { color: "#326CE5" },
          url: "https://spark.apache.org/",
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "GoogleScholar",
      iconifyClassname: "academicons:google-scholar",
      style: {
        color: "#0080f3",
      },
      profileLink:
        "https://scholar.google.es/citations?user=ZMOI-J0AAAAJ&hl=en",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/pastur",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Ph.D in Information and Communication Technologies",
      subtitle: "Faculty of Computer Science. Universidade da Coruna, Spain",
      logo_path: "udc.png",
      alt_name: "Universidade da Coruna",
      duration: "2014 - 2018",
      descriptions: [
        "Thesis Cum Laude. 'Models of information processing in the brain applied to connectionist Systems. Artificial NeuroGlial Network and Deep Learning'",
        "Innovated in the field of Deep Learning by developing novel algorithms that incorporate both neuronal and glial cell-inspired processing units",
        "Use of Tensorflow to implement the new architecture using GPU servers on CESGA supercomputer",
        "Actively engaged in research, contributing to scientific papers and project proposals, and disseminating findings at international conferences",
      ],
      website_link: "https://www.udc.es/",
    },
    {
      title: "Neuroscience Master's degree Cognitive Science specialization",
      subtitle: "Universidade da Coruna, Spain",
      logo_path: "udc.png",
      alt_name: "Universidade da Coruna",
      duration: "2013 - 2014",
      descriptions: [
        "Honor mention to the masters final project, 'Role of neurons and glial cells in information processing in the brain. Implementation of an Artificial NeuroGlial Network'",
        "Ran experiments using CESGA supercomputer",
      ],
      website_link: "https://www.udc.es/",
    },
    {
      title: "Biology degree",
      subtitle: "Universidade da Coruna, Spain",
      logo_path: "udc.png",
      alt_name: "Universidade da Coruna",
      duration: "2008 - 2013",
      descriptions: ["Environmental Biology Specialization"],
      website_link: "https://www.udc.es/",
    },
  ],
};

const certifications = {
  certifications: [
    // --- AI & Deep Learning ---
    {
      title: "Deep Learning Specialization",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://coursera.org/share/cfc4dbeefff024640c616ae26613fffc",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Aug 2018",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Build Better Generative Adversarial Networks (GANs)",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Oct 2022",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Build Basic Generative Adversarial Networks (GANs)",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Oct 2022",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Convolutional Neural Networks",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Aug 2018",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Sequence Models",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Aug 2018",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title:
        "Improving Deep Neural Networks: Hyperparameter Tuning, Regularization and Optimization",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Aug 2018",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Aug 2018",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Structuring Machine Learning Projects",
      subtitle: "- DeepLearning.AI (Coursera)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
      year: "Aug 2018",
      institution_url: "https://www.deeplearning.ai/",
    },
    {
      title: "Machine Learning",
      subtitle: "- Stanford / Coursera",
      logo_path: "stanford_logo.png",
      certificate_link: "",
      alt_name: "Stanford",
      color_code: "#8C1515",
      year: "Nov 2015",
      institution_url: "https://www.stanford.edu/",
    },
    // --- MongoDB ---
    {
      title: "M100: MongoDB for SQL Pros",
      subtitle: "- MongoDB University",
      logo_path: "mongodb_logo.svg",
      certificate_link: "",
      alt_name: "MongoDB University",
      color_code: "#FFFFFF",
      year: "Oct 2022",
      institution_url: "https://university.mongodb.com/",
    },
    {
      title: "M001: MongoDB Basics",
      subtitle: "- MongoDB University",
      logo_path: "mongodb_logo.svg",
      certificate_link: "",
      alt_name: "MongoDB University",
      color_code: "#FFFFFF",
      year: "Sep 2022",
      institution_url: "https://university.mongodb.com/",
    },
    // --- Programming & Agile ---
    {
      title: "Object-Oriented Programming in Python",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.svg",
      certificate_link: "",
      alt_name: "DataCamp",
      color_code: "#03EF62",
      year: "Sep 2020",
      institution_url: "https://www.datacamp.com/",
    },
    {
      title: "Scrum Foundation Professional Certificate (SFPC)",
      subtitle: "- CertiProf",
      logo_path: "certiprof_logo.svg",
      certificate_link: "",
      alt_name: "CertiProf",
      color_code: "#FFFFFF",
      year: "Jun 2020",
      institution_url: "https://certiprof.com/",
    },
    // --- Finance ---
    {
      title: "Financial Engineering and Risk Management Part I",
      subtitle: "- Columbia University (Coursera)",
      logo_path: "columbia_university.jpg",
      certificate_link:
        "https://coursera.org/share/ef4160a7449abfffc6d7a4a2ac13caec",
      alt_name: "Columbia University",
      color_code: "#005494",
      year: "Jan 2018",
      institution_url: "https://www.columbia.edu/",
    },
    // --- HPC / CESGA ---
    {
      title: "Introduction to TensorFlow",
      subtitle: "- CESGA",
      logo_path: "cesga_logo.svg",
      certificate_link: "",
      alt_name: "CESGA",
      color_code: "#FFFFFF",
      year: "Dec 2016",
      institution_url: "https://www.cesga.es/",
    },
    {
      title: "Taller para usuarios: Acceso a FinisTerrae-2",
      subtitle: "- CESGA",
      logo_path: "cesga_logo.svg",
      certificate_link: "",
      alt_name: "CESGA",
      color_code: "#FFFFFF",
      year: "Jun 2016",
      institution_url: "https://www.cesga.es/",
    },
    {
      title: "Introduction to Programming in CUDA",
      subtitle: "- CESGA",
      logo_path: "cesga_logo.svg",
      certificate_link: "",
      alt_name: "CESGA",
      color_code: "#FFFFFF",
      year: "Apr 2016",
      institution_url: "https://www.cesga.es/",
    },
    // --- IBM & Big Data ---
    {
      title: "Cognitive Computing",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Dec 2015",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Big Data Storage and Retrieval",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Big Data Spark Foundations",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Big Data Hadoop Foundations",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Big Data Foundations",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Big Data - Programming",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Watson Analytics Fundamentals",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Feb 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Accessing Hadoop Data Using Hive",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Using HBase for Real-time Access to your Big Data",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Introduction to MapReduce Programming",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Introduction to Pig",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "SQL Access for Hadoop",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    {
      title: "Analyzing Big Data with IBM Watson and UIMA",
      subtitle: "- IBM Big Data University",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#0530AD",
      year: "Jan 2016",
      institution_url: "https://www.ibm.com/",
    },
    // --- UC San Diego Big Data (Coursera) ---
    {
      title: "Graph Analytics for Big Data",
      subtitle: "- UC San Diego (Coursera)",
      logo_path: "UC_san_diego.png",
      certificate_link: "",
      alt_name: "UC San Diego",
      color_code: "#FFFFFF",
      year: "Feb 2016",
      institution_url: "https://ucsd.edu/",
    },
    {
      title: "Machine Learning With Big Data",
      subtitle: "- UC San Diego (Coursera)",
      logo_path: "UC_san_diego.png",
      certificate_link: "",
      alt_name: "UC San Diego",
      color_code: "#FFFFFF",
      year: "Jan 2016",
      institution_url: "https://ucsd.edu/",
    },
    {
      title: "Hadoop Platform and Application Framework",
      subtitle: "- UC San Diego (Coursera)",
      logo_path: "UC_san_diego.png",
      certificate_link: "",
      alt_name: "UC San Diego",
      color_code: "#FFFFFF",
      year: "Nov 2015",
      institution_url: "https://ucsd.edu/",
    },
    {
      title: "Introduction to Big Data Analytics",
      subtitle: "- UC San Diego (Coursera)",
      logo_path: "UC_san_diego.png",
      certificate_link: "",
      alt_name: "UC San Diego",
      color_code: "#FFFFFF",
      year: "Dec 2015",
      institution_url: "https://ucsd.edu/",
    },
    {
      title: "Introduction to Big Data",
      subtitle: "- UC San Diego (Coursera)",
      logo_path: "UC_san_diego.png",
      certificate_link: "",
      alt_name: "UC San Diego",
      color_code: "#FFFFFF",
      year: "Sep 2015",
      institution_url: "https://ucsd.edu/",
    },
    // --- Johns Hopkins ---
    {
      title: "The Data Scientist's Toolbox",
      subtitle: "- Johns Hopkins University (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Johns Hopkins University",
      color_code: "#FFFFFF",
      year: "Nov 2015",
      institution_url: "https://www.jhu.edu/",
    },
    // --- Harvard (edX) ---
    {
      title: "ER22x: Justice",
      subtitle: "- HarvardX (edX)",
      logo_path: "harvard_logo.svg",
      certificate_link: "",
      alt_name: "Harvard",
      color_code: "#A51C30",
      year: "Aug 2013",
      institution_url: "https://www.harvard.edu/",
    },
    {
      title: "CS50x Introduction to Computer Science I",
      subtitle: "- HarvardX (edX)",
      logo_path: "harvard_logo.svg",
      certificate_link: "",
      alt_name: "Harvard",
      color_code: "#A51C30",
      year: "Apr 2013",
      institution_url: "https://www.harvard.edu/",
    },
    // --- Science & Humanities (Coursera) ---
    {
      title: "Introduction to Neuroeconomics: How the Brain Makes Decisions",
      subtitle: "- Higher School of Economics (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Sep 2014",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "A Brief History of Humankind",
      subtitle: "- Hebrew University of Jerusalem (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Dec 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Dino 101: Dinosaur Paleobiology",
      subtitle: "- University of Alberta (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Nov 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "From the Big Bang to Dark Energy",
      subtitle: "- University of Tokyo (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Oct 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Disaster Preparedness",
      subtitle: "- University of Pittsburgh (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Oct 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Introduction to Sustainability",
      subtitle: "- University of Illinois (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Oct 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Animal Behaviour",
      subtitle: "- University of Melbourne (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Oct 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Climate Change",
      subtitle: "- University of Melbourne (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Oct 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "The Science of Gastronomy",
      subtitle: "- Hong Kong University of Sci & Tech (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Aug 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Epigenetic Control of Gene Expression",
      subtitle: "- University of Melbourne (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Aug 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Computational Molecular Evolution",
      subtitle: "- Technical University of Denmark (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Aug 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Internet History, Technology, and Security",
      subtitle: "- University of Michigan (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Aug 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Genes and the Human Condition (From Behavior to Biotechnology)",
      subtitle: "- University of Maryland (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Jun 2013",
      institution_url: "https://www.coursera.org/",
    },
    {
      title: "Synapses, Neurons and Brains",
      subtitle: "- Hebrew University of Jerusalem (Coursera)",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#FFFFFF",
      year: "Jun 2013",
      institution_url: "https://www.coursera.org/",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Startup, Enterprise & Academia",
  description:
    "I co-founded Artiso AI to fix how fashion teams work with AI. Before that I spent 4 years at Mango shipping GenAI tools, 1 year at Grifols building their AI Center of Excellence, and 3 years managing 30+ ML projects in consulting. I also teach AI and design at LCI Barcelona.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "CPO & Co-Founder",
          company: "Artiso AI",
          company_url: "https://www.artiso.ai/",
          logo_path: "artiso.svg",
          duration: "May 2025 - Present",
          location: "Barcelona, Spain",
          description:
            "Co-founded Artiso AI, an AI SaaS platform for fashion creatives. We cover the full workflow: moodboards, silhouettes, prints, variants, tech packs. Featured in Le Monde, FashionUnited, Modaes, La Vanguardia. Awarded leading startup at Juno House.",
          color: "#000000",
        },
        {
          title: "University Professor",
          company: "LCI Barcelona",
          company_url: "https://www.lcibarcelona.com/",
          logo_path: "LCI.svg",
          duration: "Oct 2023 - Present",
          location: "Barcelona, Spain",
          description:
            "Teaching Digital Creation (2D/3D/CGI) and AI for fashion and creative industries. Created Groovify, an app shown at Sonar+D 2024 that reads your outfit and picks your playlist. Curriculum: Midjourney, Firefly, Stable Diffusion, 3D/video gen.",
          color: "#000000",
        },
        {
          title: "AI Architect Manager",
          company: "Grifols",
          company_url: "https://www.grifols.com/",
          logo_path: "grifols.svg",
          duration: "Jul 2024 - Jul 2025",
          location: "Barcelona, Spain",
          description:
            "Led AI architecture for Grifols' AI Center of Excellence. Built a multi-agent platform covering 20+ use cases: R&D, finance, cybersecurity, HR, QA, manufacturing. Reference architectures aligned with FDA/EMA pharma regulations.",
          color: "#0879bf",
        },
        {
          title: "Manager Data Scientist - Generative AI",
          company: "Mango fashion group",
          company_url: "https://www.mangofashiongroup.com/",
          logo_path: "mango.jpg",
          duration: "Apr 2023 - Jun 2024",
          location: "Barcelona, Spain",
          description:
            "Led GenAI adoption company-wide. Built Lisa (conversational AI, 50+ use cases) and Inspire (image generation for designers). Trained 100+ creatives. Took AI from pilot experiments to daily production tools.",
          color: "#0879bf",
        },
        {
          title: "Manager Data Scientist - Product squad",
          company: "Mango fashion group",
          company_url: "https://www.mangofashiongroup.com/",
          logo_path: "mango.jpg",
          duration: "Jan 2022 - Apr 2023",
          location: "Barcelona, Spain",
          description:
            "Built AI-powered size curve predictions to optimize inventory. Started a computer vision workstream for product visual similarity. Projects across purchase, design, and pattern making.",
          color: "#0879bf",
        },
        {
          title: "Lead Data Scientist - Pricing squad",
          company: "Mango fashion group",
          company_url: "https://www.mangofashiongroup.com/",
          logo_path: "mango.jpg",
          duration: "Oct 2020 - Jan 2022",
          location: "Barcelona, Spain",
          description:
            "Product owner for Midas, Mango's ML pricing platform. Covered \u20ac400M in annual priced sales, \u20ac20M+ incremental revenue. 95% of AI price proposals accepted by pricing teams. Cut compute costs 50% by re-architecting Big Data pipelines.",
          color: "#0879bf",
        },
        {
          title: "Innovation Area Manager",
          company: "Grupo AIA",
          company_url: "https://aia.es/",
          logo_path: "AIA.png",
          duration: "Jan 2019 - Oct 2020",
          location: "Barcelona, Spain",
          description:
            "Managed 10+ data scientists, delivered 30+ ML projects in finance, telco, retail, healthcare. Credit risk, anomaly detection, NLP, graph analytics, bioinformatics.",
          color: "#9b1578",
        },
        {
          title: "Senior Data Scientist",
          company: "Grupo AIA",
          company_url: "https://aia.es/",
          logo_path: "AIA.png",
          duration: "Feb 2018 - Dec 2018",
          location: "Barcelona, Spain",
          description:
            "End-to-end data science projects. Sales forecasting models, Deep Learning for real-time industrial process prediction. Docker-based production deployment.",
          color: "#9b1578",
        },
        {
          title: "Data Scientist",
          company: "KDP (CaixaBank & AIA Joint Venture)",
          company_url: "https://aia.es/",
          logo_path: "kdp.png",
          duration: "Oct 2017 - Jan 2018",
          location: "Barcelona, Spain",
          description:
            "Econometric and ML models for financial asset valuation. GBM for loan prepayment prediction, Monte Carlo simulations. Text mining with TF-IDF, LDA, Spark clustering.",
          color: "#9b1578",
        },
        {
          title: "R+D Technical Staff",
          company: "Universidade da Coru\u00f1a",
          company_url: "https://www.udc.es/",
          logo_path: "udc.png",
          duration: "Oct 2016 - Sept 2017",
          location: "A Coru\u00f1a, Spain",
          description:
            "Built novel Deep Learning algorithms with neuronal and glial cell-inspired processing units (TensorFlow, Keras). Published at international AI and Neuroscience conferences.",
          color: "#9b1578",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description: "Some things I built at companies, some on my own time",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "artiso-ai-platform",
      name: "Artiso AI",
      createdAt: "2025-05",
      description:
        "AI SaaS platform for fashion creatives. Covers the full workflow from first mood to final tech pack. Featured in Le Monde, FashionUnited, Modaes.",
      url: "https://www.artiso.ai",
    },
    {
      id: "lisa-mango",
      name: "Lisa (Mango)",
      createdAt: "2023-10",
      description:
        "Mango's internal conversational AI platform. 50+ use cases across all departments.",
      url:
        "https://www.mangofashiongroup.com/en/w/mango-lanza-su-propia-plataforma-de-ia-generativa-conversacional-denominada-lisa",
    },
    {
      id: "inspire-mango",
      name: "Inspire (Mango)",
      createdAt: "2022-11",
      description:
        "Image generation tool for Mango's design team. Used daily for prints, fabrics, garment concepts.",
      url:
        "https://www.mangofashiongroup.com/en/w/mango-lanza-su-propia-plataforma-de-ia-generativa-conversacional-denominada-lisa",
    },
    {
      id: "groovify",
      name: "Groovify (Sonar+D 2024)",
      createdAt: "2024-06",
      description:
        "App shown at Sonar+D 2024. Reads your outfit, picks your playlist, generates a custom single with cover art.",
      url: "https://www.lcibarcelona.com/",
    },
    {
      id: "fashion-runway-shows",
      name: "Fashion Runway Trend Detection",
      createdAt: "2023-06",
      description:
        "PoC using ChatGPT to pull structured data from runway shows and spot trends across designers.",
      url: "https://github.com/pasturl/fashion-runway-shows",
    },
    {
      id: "hack4nf-2022",
      name: "Hack4NF 2022",
      createdAt: "2022-10",
      description:
        "Won best page award. Cancer type prediction from genomic data, published in Cancer Research.",
      url: "https://github.com/pasturl/Hack4NF-2022",
    },
    {
      id: "virtual-makeup",
      name: "Virtual Makeup",
      createdAt: "2023-01",
      description:
        "Virtual makeup try-on with facial landmark detection and real-time image processing.",
      url: "https://github.com/pasturl/virtual_makeup",
    },
  ],
};

const publicationsHeader = {
  title: "Publications",
  description:
    "Peer-reviewed papers from my PhD and side projects. Cum Laude in AI. Google Scholar profile: 200+ citations.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "pub-hack4nf-2023",
      name:
        "Crowdsourcing rare cancer research in the Hack4NF GENIE-NF tumor identification and classification challenge",
      createdAt: "2023-06-14",
      description: "Cancer Research, 83(13), 2228. AACR, 2023",
      url: "https://aacrjournals.org/cancerres/article/83/13/2228/727438",
      abstract:
        "We describe the results of the Hack4NF GENIE-NF challenge, a crowdsourced competition to identify and classify tumors associated with neurofibromatosis using genomic data from the AACR Project GENIE dataset. Multiple teams developed ML models for tumor classification achieving strong predictive performance.",
      keywords: [
        "Cancer Research",
        "Neurofibromatosis",
        "Genomics",
        "Crowdsourcing",
        "Machine Learning",
        "Tumor Classification",
      ],
    },
    {
      id: "pub-braf-2022",
      name:
        "Machine learning techniques in predicting BRAF mutation status in cutaneous melanoma from clinical and histopathologic features",
      createdAt: "2022-11-01",
      description:
        "Applied Immunohistochemistry & Molecular Morphology, 30(10), 674-680. 2022",
      url:
        "https://journals.lww.com/appliedimmunohist/fulltext/2022/11000/machine_learning_techniques_in_predicting_braf.5.aspx",
      abstract:
        "BRAF mutation evaluation is routine in cutaneous melanoma. We trained multiple ML classifiers on clinical and histopathologic features to predict BRAF V600E mutation status, showing that ensemble methods (Gradient Boosting, Random Forest) can accurately predict mutation status from non-molecular data.",
      keywords: [
        "Melanoma",
        "BRAF Mutation",
        "Machine Learning",
        "Histopathology",
        "Gradient Boosting",
        "Predictive Modeling",
      ],
    },
    {
      id: "pub-astrocyte-2017",
      name: "Artificial astrocytic modulation of neuron's output",
      createdAt: "2017-09-01",
      description:
        "Proceedings of the 10th International Work-Conference on the Interplay Between Natural and Artificial Computation (IWINAC), Springer, 2017",
      url: "https://link.springer.com/chapter/10.1007/978-981-10-5122-7_228",
      abstract:
        "Astrocytes are key players in synapse formation and in enhancing neuronal synchrony by regulating stochastic neuronal spiking. We present a computational model of artificial astrocytic modulation that improves information processing in neural networks by incorporating glial cell dynamics.",
      keywords: [
        "Astrocytes",
        "Glial Cells",
        "Neural Networks",
        "Computational Neuroscience",
        "Neuromorphic Computing",
      ],
    },
    {
      id: "pub-magnolol-2017",
      name:
        "General machine learning model, review, and experimental-theoretic study of magnolol activity in enterotoxigenic induced oxidative stress",
      createdAt: "2017-01-01",
      description: "Current Topics in Medicinal Chemistry, 17(31), 2017",
      url: "https://www.eurekaselect.com/article/80524",
      abstract:
        "We developed a general ML model combining experimental and theoretical descriptors to predict magnolol bioactivity against enterotoxigenic-induced oxidative stress. The model incorporates perturbation theory to handle multi-target activity prediction across different biological assays.",
      keywords: [
        "Magnolol",
        "Oxidative Stress",
        "Machine Learning",
        "Perturbation Theory",
        "Drug Discovery",
        "Bioactivity Prediction",
      ],
    },
    {
      id: "pub-parallel-2017",
      name: "Parallel computing for brain simulation",
      createdAt: "2017-01-01",
      description: "Current Topics in Medicinal Chemistry, 17(14), 2017",
      url: "https://pubmed.ncbi.nlm.nih.gov/27823566/",
      abstract:
        "Brain simulation requires massive computational resources due to the complexity of neural circuits. This work reviews parallel computing approaches for large-scale brain simulations, including GPU-based and distributed computing strategies for modeling neural networks at biologically realistic scales.",
      keywords: [
        "Brain Simulation",
        "Parallel Computing",
        "GPU Computing",
        "Neural Networks",
        "High Performance Computing",
      ],
    },
    {
      id: "pub-dnn-2016",
      name:
        "Deep artificial neural networks and neuromorphic chips for big data analysis: pharmaceutical and bioinformatics applications",
      createdAt: "2016-08-16",
      description:
        "International Journal of Molecular Sciences, 17(8), 1313. MDPI, 2016. 150+ citations.",
      url: "https://www.mdpi.com/1422-0067/17/8/1313",
      abstract:
        "Deep Artificial Neural Networks (DNNs) have become the state-of-the-art algorithms in Machine Learning, speech recognition, computer vision, NLP and many other tasks. This review covers DNNs and neuromorphic chips for big data analysis in pharmaceutical and bioinformatics applications, pointing out the importance of including glial cells (astrocytes) in neural network architectures.",
      keywords: [
        "Deep Learning",
        "Neuromorphic Computing",
        "Big Data",
        "Pharmaceuticals",
        "Bioinformatics",
        "Astrocytes",
        "GPU Computing",
      ],
      figures: [
        {
          src:
            "https://pub.mdpi-res.com/ijms/ijms-17-01313/article_deploy/html/images/ijms-17-01313-g001.png",
          caption:
            "Architecture of deep neural networks with multiple hidden layers for feature extraction",
        },
        {
          src:
            "https://pub.mdpi-res.com/ijms/ijms-17-01313/article_deploy/html/images/ijms-17-01313-g002.png",
          caption:
            "Neuromorphic chip architecture inspired by biological neural circuits",
        },
        {
          src:
            "https://pub.mdpi-res.com/ijms/ijms-17-01313/article_deploy/html/images/ijms-17-01313-g003.png",
          caption:
            "Astrocyte-neuron interaction model for enhanced information processing",
        },
      ],
    },
    {
      id: "pub-brain-models-2015",
      name: "Computational models of the brain",
      createdAt: "2015-12-01",
      description: "MOL2NET, 1, 2015. doi:10.3390/MOL2NET-1-E009",
      url: "https://doi.org/10.3390/MOL2NET-1-E009",
      abstract:
        "This work presents computational models of the brain that integrate artificial neural network architectures with biologically inspired components, reviewing the state of the art in brain modeling and simulation techniques.",
      keywords: [
        "Brain Modeling",
        "Computational Neuroscience",
        "Neural Networks",
        "Simulation",
      ],
    },
  ],
};

// Media & Press
const mediaSection = {
  title: "Media & Press",
  description:
    "Artiso AI and my work covered by international media, conferences, and industry events.",
  personal: [
    {
      name: "Cadena SER",
      title: "Lucas Pastur, fundador de Artiso, la nueva plataforma de IA para la moda",
      url: "https://cadenaser.com/audio/1752150260110/",
      date: "2025-07-14",
      type: "audio",
      icon: "simple-icons:iheartradio",
      thumbnail_url: "",
    },
    {
      name: "Cadena SER",
      title: "Artiso, la plataforma que revoluciona la moda con IA",
      url: "https://cadenaser.com/galicia/2025/07/10/artiso-la-plataforma-que-revoluciona-la-moda-con-inteligencia-artificial-radio-coruna/",
      date: "2025-07-10",
      type: "audio",
      icon: "simple-icons:iheartradio",
      thumbnail_url: "",
    },
    {
      name: "FashionUnited (ES)",
      title: "El equipo de IA de Mango se independiza y lanza Artiso",
      url: "https://fashionunited.es/noticias/empresas/el-equipo-de-ia-de-mango-se-independiza-y-lanza-artiso-una-plataforma-integral-de-ia-para-el-diseno-de-moda/2025070946375",
      date: "2025-07-09",
      type: "article",
      icon: "mdi:newspaper-variant-outline",
      thumbnail_url: "https://r.fashionunited.com/LqrBSOwGm5NNuS4uWmuKRUc09KLJ00Z7APhS7N3xIm4/resize:fit:1200:630:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9pbWcvdXBsb2FkLzIwMjUvMDcvMDkvYXJ0aXNvLTEtcDJvbmFqd2otMjAyNS0wNy0wOS5qcGVn.jpeg",
    },
    {
      name: "MedIA-Talks (MediaMarkt)",
      title: "Shaping the Future of Fashion with AI",
      url: "https://www.linkedin.com/posts/media-markt-espa%C3%B1a_letsgomediamarkt-mediamarktpeople-activity-7333481132430143493-Uxjh/",
      date: "2025-06-29",
      type: "video",
      icon: "mdi:video-outline",
      thumbnail_url: "",
    },
    {
      name: "Mango Corporate",
      title: "Pioneering AI-Generated Campaigns in Fashion Design",
      url: "https://www.linkedin.com/posts/sarahiglesiashiller_mango-corporate-innovation-activity-7217045026579636224-6a35/",
      date: "2024-06-26",
      type: "article",
      icon: "mdi:briefcase-outline",
      thumbnail_url: "",
    },
  ],
  artiso: [
    {
      name: "La Vanguardia",
      title: "Artiso, una startup al servicio de la moda",
      url: "https://www.lavanguardia.com/economia/emprendedores/20250830/10997505/startup-servicio-moda-artiso.html",
      date: "2025-08-30",
      type: "article",
      icon: "mdi:newspaper-variant-outline",
      thumbnail_url: "https://www.lavanguardia.com/files/og_thumbnail/files/fp/uploads/2025/08/23/68aa208b59116.r_d.1574-1155-4000.jpeg",
    },
    {
      name: "Modaes",
      title: "Mango as a lab: three former managers launch AI platform for fashion design",
      url: "https://www.modaes.com/global/back-stage/mango-as-a-lab-three-former-managers-launch-ai-platform-for-fashion-design",
      date: "2025-07-09",
      type: "article",
      icon: "mdi:newspaper-variant-outline",
      thumbnail_url: "",
    },
    {
      name: "FashionUnited (EN)",
      title: "A Spanish startup launches AI tool to streamline fashion's creative engine",
      url: "https://fashionunited.uk/news/fashion/a-spanish-startup-launches-ai-tool-to-streamline-fashions-creative-engine/2025070882691",
      date: "2025-07-08",
      type: "article",
      icon: "mdi:newspaper-variant-outline",
      thumbnail_url: "https://r.fashionunited.com/QZF3j0E3KS9RTCiK2XbI5C7tVJp5r_zSfyGIQ_8cITw/resize:fit:1200:630:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9pbWcvdXBsb2FkLzIwMjUvMDcvMDgvMTc1MTg4MzcyMTkwMS13cHM4dmxiZS0yMDI1LTA3LTA4LmpwZWc.jpeg",
    },
    {
      name: "Minmote (Norway)",
      title: "How AI Is Changing the Fashion Industry",
      url: "https://www.minmote.no/nyheter/a/zAV851/ai-mote-shopping",
      date: "2024-12-13",
      type: "article",
      icon: "mdi:newspaper-variant-outline",
      thumbnail_url: "",
    },
    {
      name: "Tech Spirit BCN",
      title: "Keynote: AI, the new language of creativity",
      url: "https://techspirit.barcelona/es/speakers/sarah-iglesias/",
      date: "2025-12-11",
      type: "event",
      icon: "mdi:microphone-variant",
      thumbnail_url: "",
    },
    {
      name: "TEDx",
      title: "TEDx King Juan Carlos University",
      url: "https://www.linkedin.com/posts/sarahiglesiashiller_artiso-tedx-fashiontech-activity-7402251582333005824-4kW9",
      date: "2025-11-27",
      type: "video",
      icon: "mdi:video-outline",
      thumbnail_url: "",
    },
    {
      name: "IESE Business School",
      title: "How leaders approach AI implementation",
      url: "https://www.linkedin.com/posts/sarahiglesiashiller_iese-artiso-activity-7407325051210895360-JDkB",
      date: "2025-12-10",
      type: "article",
      icon: "mdi:school-outline",
      thumbnail_url: "",
    },
    {
      name: "La Vanguardia",
      title: "Reimagine Textile Day: AI roundtable with Artiso AI cofounders",
      url: "https://www.lavanguardia.com/economia/innovacion/20251031/11217142/reimagine-textile-day-celebra-quinta-edicion-centrando-foco-inteligencia-artificial-reciclaje-moda-brl.html",
      date: "2025-10-31",
      type: "article",
      icon: "mdi:newspaper-variant-outline",
      thumbnail_url: "https://www.lavanguardia.com/files/og_thumbnail/uploads/2025/10/31/690485ca7164c.gif",
    },
    {
      name: "Juno House",
      title: "Artiso AI awarded leading startup at Juno House",
      url: "https://www.netmentoracatalunya.org/post/cuando-falta-diversidad-lo-que-se-pierde-no-es-representaci%C3%B3n-es-inteligencia",
      date: "2025-11-20",
      type: "article",
      icon: "mdi:trophy-outline",
      thumbnail_url: "https://static.wixstatic.com/media/7a5aa0_68ea2f263a6e4ed6b7fb844302726cdb~mv2.png/v1/fill/w_1000,h_563,al_c,q_90,usm_0.66_1.00_0.01/7a5aa0_68ea2f263a6e4ed6b7fb844302726cdb~mv2.png",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "lucas.jpg",
    description:
      "Drop me a line on LinkedIn or email. Happy to talk about Artiso, AI in fashion, or anything interesting.",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //   link: "https://blogs.ashutoshhathidara.com/",
  //   avatar_image_path: "blogs_image.svg",
  // },
  addressSection: {
    title: "Address",
    subtitle: "Barcelona",
    locality: "Barcelona",
    country: "Spain",
    region: "Cataluña",
    postalCode: "08010",
    streetAddress: "Barcelona",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/wWz2TC4YoVyt6tVH9",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  projects,
  publicationsHeader,
  publications,
  mediaSection,
  contactPageData,
};
